import LoginButtonTemplate from "./LoginButtonTemplate";
import useGoogleLogin from "hooks/useGoogleLogin";
import useMixpanelWeb from "hooks/useMixpanelWeb";
import { useRecoilValue } from "recoil";
import { userAtom } from "recoil/userAtom";

export default function GoogleLoginButton({
  render,
}: {
  render?: (props: {
    onClick: (e?: any) => void;
    disabled?: boolean;
  }) => JSX.Element;
}) {
  const handleGoogleLogin = useGoogleLogin();
  const user = useRecoilValue(userAtom);

  const trackLoginButtonClick = useMixpanelWeb({
    eventName: "로그인 버튼 클릭",
    params: { method: "google" },
  });

  return (
    <LoginButtonTemplate
      loginType="google"
      action={() => {
        trackLoginButtonClick();
        handleGoogleLogin();
      }}
      isLoggedIn={!!user?.accessToken}
    />
  );
}
